import {FC, ReactElement} from "react";

import DataInfo from "components/data-info";
import {Box, Text, Spinner} from "@chakra-ui/react";

type DataBoxProps = {
    data: Record<string | number | symbol, any> | null;
    error: boolean;
    isLoading: boolean;
};

const DataBox: FC<DataBoxProps> = ({data, error, isLoading}) => {
    let $content: ReactElement | null = null;

    if (data) {
        $content = (
            <Box
                d={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                flexDir={{base: "column", sm: "row"}}
                w={"100%"}
            >
                <DataInfo title={"IP ADDRESS"} data={data.ip} />
                <DataInfo
                    title={"LOCATION"}
                    data={[
                        `${data.location.city}, ${data.location.country}`,
                        `${data.location.postalCode}`,
                    ]}
                />
                <DataInfo
                    title={"TIMEZONE"}
                    data={`UTC ${data.location.timezone}`}
                />
                <DataInfo title={"ISP"} data={data.isp} border={"none"} />
            </Box>
        );
    }

    if (isLoading) {
        $content = (
            <Box
                w={"100%"}
                h={"100%"}
                d={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Spinner size={"xl"} color={"lightGrey"} />
            </Box>
        );
    }

    if (error) {
        $content = (
            <Box
                w={"100%"}
                h={"100%"}
                d={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Text>{"Your search did not work."}</Text>
            </Box>
        );
    }

    return (
        <Box
            d={"flex"}
            bgColor={"#fff"}
            w={"80vw"}
            h={{base: "100%", sm: "10rem"}}
            borderRadius={"16px"}
            boxShadow={"md"}
            position={"absolute"}
            bottom={{base: "-8rem", sm: "-5rem"}}
            zIndex={1}
        >
            {$content}
        </Box>
    );
};

export default DataBox;
